import * as React from 'react';
import { warnWithTrace } from '../helpers/logger';
import { css, styled, useTheme } from '../theme-provider';
const getTextAppearance = (theme, appearance) => {
    if (!appearance) {
        return theme.fonts['copy']['200'];
    }
    const [, fontKey, fontSizeKey] = appearance.match(/([a-z]{1,25})(\d{1,10})/);
    return theme.fonts[fontKey][parseInt(fontSizeKey, 10)];
};
function createFontStyles(props) {
    const { appearance, theme, textColor } = props;
    const textAppearance = getTextAppearance(theme, appearance);
    if (!textAppearance) {
        warnWithTrace(`The textAppearance ${appearance} could not be found`);
        return '';
    }
    const { fontFamily, fontSize, letterSpacing, lineHeight } = textAppearance;
    return css `font-family:${fontFamily};font-size:${fontSize};line-height:${lineHeight};letter-spacing:${letterSpacing};color:${textColor};margin:unset;`;
}
const translateX = css `translateX(\n\t${({ theme }) => theme.direction === 'rtl'
    ? `min(2em, ${theme.size.static510})`
    : `max(-2em, -${theme.size.static510})`}\n);`;
const StyledListItem = styled.li.withConfig({ displayName: "StyledListItem", componentId: "sc-112v5tu" }) `${(props) => createFontStyles(props)};padding-inline-start:min(2em, ${({ theme }) => theme.size.static510});position:relative;&::before{transform:translateX(max(-2em, -${({ theme }) => theme.size.static510}));position:absolute;font-weight:bold;}ul > &::before{transform:${translateX};position:absolute;content:'\\2014';}ol > &{counter-increment:items;::before{transform:${translateX};content:${({ markerSize }) => `"${'0'.repeat(markerSize)}" counter(items)`};}}`;
export const ListItem = ({ children, markerSize = 2, appearance, }) => {
    const theme = useTheme();
    return (React.createElement(StyledListItem, { markerSize: markerSize, appearance: appearance, textColor: theme.colors.content.primary }, children));
};
